import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useApp } from "../context/AppContext";

export default function SetPassword() {
  const { setPassword } = useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPasswordValue] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { setError("La contraseña debe tener al menos 6 caracteres."); return; }
    if (password !== password2) { setError("Las contraseñas no coinciden."); return; }
    setError("");
    setLoading(true);
    try {
      await setPassword(token, password);
      setDone(true);
      setTimeout(() => navigate("/my-ad"), 1200);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={s.wrap}>
        <div style={s.card}>
          <div style={{fontSize:48,textAlign:"center"}}>❌</div>
          <p style={s.title}>Link invalido</p>
        </div>
      </div>
    );
  }

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        {done ? (
          <>
            <div style={{fontSize:48,textAlign:"center"}}>✅</div>
            <p style={s.title}>Contraseña creada!</p>
            <p style={s.text}>Te estamos llevando a tu panel...</p>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={s.title}>Crea tu contraseña</p>
            <p style={s.text}>Vas a usarla para entrar a ver el estado de tu publicidad.</p>
            <input style={s.input} type="password" placeholder="Contraseña" value={password}
              onChange={e => setPasswordValue(e.target.value)} />
            <input style={s.input} type="password" placeholder="Repetir contraseña" value={password2}
              onChange={e => setPassword2(e.target.value)} />
            {error && <p style={s.error}>{error}</p>}
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? "Guardando..." : "Crear contraseña"}
            </button>
            <Link to="/login" style={s.link}>Ya tengo cuenta, quiero iniciar sesion</Link>
          </form>
        )}
      </div>
    </div>
  );
}

const s = {
  wrap:{minHeight:"calc(100vh - 68px)",background:"#f5f5f5",display:"flex",alignItems:"center",justifyContent:"center",padding:20},
  card:{background:"#fff",borderRadius:16,padding:"36px 32px",width:"100%",maxWidth:400,boxShadow:"0 2px 16px rgba(0,0,0,0.06)",textAlign:"center"},
  title:{fontSize:22,fontWeight:600,color:"#111",marginBottom:8},
  text:{fontSize:14,color:"#666",lineHeight:1.6,marginBottom:20},
  input:{width:"100%",height:46,padding:"0 16px",borderRadius:10,border:"1px solid #e4e4e4",fontSize:15,marginBottom:12,outline:"none",boxSizing:"border-box"},
  error:{color:"#E24B4A",fontSize:13,marginBottom:12},
  btn:{width:"100%",background:"#1D9E75",color:"#fff",border:"none",borderRadius:10,padding:"13px",fontSize:15,fontWeight:600,cursor:"pointer"},
  link:{display:"block",marginTop:16,fontSize:13,color:"#1D9E75",textDecoration:"none"},
};
